<div class="inspHRation-wrapper">
  <div class="icon-holder">
    <mat-icon matBadgeOverlap="true" matBadgeSize="large"
            [svgIcon]="inspHRation.overrideIcon? inspHRation.overrideIcon : inspHRation.shoutOutType.icon"
            [matBadge]="count? count : undefined"
            matBadgeColor="primary" matBadgeDescription="Number of inspHRations received"></mat-icon>
  </div>
  <span class="title">{{inspHRation.overrideTitle}}</span>
</div>
